export const refreshTokenExpiration = 30 * 86400; // = 30 days
